import React from 'react';
import { useTranslation } from 'react-i18next';
import ResultDisplay from 'components/resultDisplay/ResultDisplay';
import './RegistrationSuccess.scss';
import registrationSuccessIcon from 'assets/images/registration_success.png';
import { useNavigate } from 'react-router-dom';
import { buildLoginPath } from 'utils/pathBuilder';
import { useAutoNavigate } from 'hooks/useAutoNavigate';

const RegistrationSuccess: React.FC = () => {
  const { t } = useTranslation('registration');
  const navigate = useNavigate();

  useAutoNavigate(buildLoginPath());

  return (
    <ResultDisplay
      title={t('success.title')}
      imageUrl={registrationSuccessIcon}
      showFooter={true}
      onNext={() => navigate(buildLoginPath())}
      nextText={t('success.goToLoginButton')}
    >
      <div className="registration-success-message">
        <div>{t('success.message1')}</div>
        <div>{t('success.message2')}</div>
      </div>
    </ResultDisplay>
  );
};

export default RegistrationSuccess;
